<template>
  <el-main>
    <h3 class="title">{{ msgRes.title }}</h3>
    <div class="other_info" v-if="msgRes.publish_time">
      <div class="time">
        發佈時間：{{ $dayjs(msgRes.publish_time).format("YYYY-MM-DD") }}
      </div>
    </div>
    <div v-html="msgRes.content" class="con"></div>
    
  </el-main>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data(){
    return{
      msgRes:{}
    }
  },
  computed:{
    ...mapState(['user_id'])
  },
  watch:{
    user_id(val){
      this.getMsgDetails()
    }
  },
  methods:{
    async getMsgDetails() {
      const { data: res } = await this.$http.get(`/api/v2/notice/${this.$route.query.id}/${this.user_id}`);
      // console.log('获取消息详情===',res);
      if (res.code !== "200") return false;
      this.msgRes=res.data
    },
  },
  mounted() {
    if(!this.$route.query.id){
      this.$router.push({
        path: `/`,
      })
    }
    if(this.user_id){
      this.getMsgDetails()
    }
  },
}
</script>

<style lang="less" scoped> 
.el-main {
  width: 900px;
  .title {
    font-size: 22px;
    font-weight: 400;
    color: rgba(1, 1, 1, 1);
    line-height: 22px;
    text-align: center;
    margin-bottom: 18px;
    margin-top: 40px;
  }
  .other_info {
    text-align: center;
    position: relative;
    margin-bottom: 40px;
    .time {
      font-size: 16px;
      // font-weight: 300;
      color: #333333;
      line-height: 48px;
    }
  }
  /deep/ .con {
    color: #424242;
    font-size: 18px;
    line-height: 48px;
    img{
      margin: auto;
      display: block;
    }
  }
}
@media screen and (max-width: 768px){
  .el-main {
  width: 100%;
  padding: 0 20px;
  .con{
    line-height: 30px;
  }
  }
}
</style>